import { useEffect, useState } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { experimentalStyled } from '@material-ui/core';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';

import Account from 'src/pages/user/Account';
import CustomerList from 'src/pages/user/CustomerList';
import ProductList from 'src/pages/user/ProductList';
import Settings from 'src/pages/user/Settings';
import CreditLevel from 'src/pages/updates/CreditLevel';

//Redux
import { useSelector, useDispatch } from "react-redux";
import {  logout } from '../../redux/actions/auth';

//My Components
import Calculator from 'src/pages/user/Applications';
import TestPage from 'src/pages/user/testPage';
import Verify from 'src/pages/updates/Verify';
import Pay from 'src/pages/updates/Pay';
import Dashboard from 'src/pages/user/Dashboard';
import Transactions from 'src/pages/updates/Transactions';
import Payments from 'src/pages/updates/Payments';


import UserRoute from 'src/UserRoutes'


const DashboardLayoutRoot = experimentalStyled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'

  })
);

const DashboardLayoutWrapper = experimentalStyled('div')(
  ({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  })
);

const DashboardLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const DashboardLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto'
});

const DashboardLayout = () => {
  const dispatch = useDispatch();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [isAuth, setAuth] = useState(false);

  const { isLoggedIn } = useSelector((state) => state.auth);



  return (
    <DashboardLayoutRoot>
      <DashboardNavbar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <DashboardSidebar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <UserRoute path="/app/account" component={Account} />
            <UserRoute path="/app/customers" component={CustomerList} />
            <UserRoute path="/app/products" component={ProductList} />
            <UserRoute path="/app/settings" component={Settings} />
            <UserRoute path="/app/calculator" component={Calculator} />
            <UserRoute path="/app/questionnaire" component={TestPage} />
            <UserRoute path="/app/applications" component={Calculator} />
            <UserRoute path="/app/financing" component={CreditLevel} />
            <UserRoute path="/app/transactions" component={Transactions} />
            <UserRoute path="/app/cashout" component={Payments} />
            <UserRoute path="/app/verify" component={Verify} />
            <UserRoute path="/app/pay" component={Pay} />

            {/* //TestUserRoute */}

            {/* <Outlet /> */}
            <UserRoute path="/app/dashboard" component={Dashboard} />
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
